export const OPEN_HEADER_SEARCH = "OPEN_HEADER_SEARCH";
export const CLOSE_HEADER_SEARCH = "CLOSE_HEADER_SEARCH";
